// A mandatory column left empty is reported either with zod's own "received null" message
// or, when the schema sets a custom message, with the shared (required) key.
const REQUIRED_ERROR_PATTERNS = [/^Expected.*received null$/, /\(required\)/];

/**
 * Tells whether a bulk upload validation error means "this mandatory cell is empty",
 * which the BO displays with the shared "missing required data" message.
 */
export function isRequiredFieldError(error: string): boolean {
  return REQUIRED_ERROR_PATTERNS.some((pattern) => pattern.test(error));
}
